import React from 'react';
import remarkGfm from 'remark-gfm';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import './index.scss';
import onClickLink from '@/utils/on-click-link';
import onClickImg from '@/utils/on-click-img';
import CodeBlock from './code-block';

const Markdown = ({ text }) => {
  if (!text) {
    return null;
  }
  return (
    <>
      <ReactMarkdown
        className="chatai-ui-markdown"
        rehypePlugins={[rehypeRaw]}
        remarkPlugins={[[remarkGfm, { singleTilde: false }]]}
        components={{
          a({ node, inline, className, children, ...props }) {
            const href = node?.properties?.href || props.href;
            return (
              <a
                {...props}
                className={className}
                onClick={(e) => {
                  e.preventDefault();
                  onClickLink(href);
                }}
              >
                {children}
              </a>
            );
          },
          img({ node, inline, className, children, ...props }) {
            return (
              <img
                {...props}
                className={className}
                onClick={(e) => {
                  const inAnchor = !!e.target.closest('a');
                  if (inAnchor) return;
                  e.preventDefault();
                  onClickImg(
                    [
                      {
                        src: props.src,
                        width: e.target.naturalWidth,
                        height: e.target.naturalHeight,
                        alt: props.alt,
                      },
                    ],
                    0,
                  );
                }}
              />
            );
          },
          code({ node, inline, className, children, ...props }) {
            const match = /language-(\w+)/.exec(className || '');
            const language = match ? match[1] : '';
            return !inline ? (
              <CodeBlock language={language}>{children}</CodeBlock>
            ) : (
              <code {...props} className={className}>
                {children}
              </code>
            );
          },
        }}
      >
        {text}
      </ReactMarkdown>
    </>
  );
};

export default Markdown;
